var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconeHp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 334.526,
    height: 47.748,
    viewBox: "0 0 334.526 47.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_7484",
    "data-name": "Raggruppa 7484",
    transform: "translate(-28 -211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PRIMER_PLATO",
    "data-name": "PRIMER PLATO",
    transform: "translate(5.34 183.63)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linea_805",
    "data-name": "Linea 805",
    x2: 17.995,
    transform: "translate(41.65 70.131)",
    fill: "none",
    stroke: "#262c62",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_15995",
    "data-name": "Tracciato 15995",
    d: "M73.637,63.57A27.676,27.676,0,0,1,59.63,87.558v3a.981.981,0,0,1-.981.981h-20a.981.981,0,0,1-.981-.981v-3A27.676,27.676,0,0,1,23.66,63.57Z",
    transform: "translate(0 -17.427)",
    fill: "none",
    stroke: "#262c62",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_15996",
    "data-name": "Tracciato 15996",
    d: "M47.709,88.552A21.614,21.614,0,0,1,37.66,75.8",
    transform: "translate(-7.134 -23.658)",
    fill: "none",
    stroke: "red",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_15997",
    "data-name": "Tracciato 15997",
    d: "M73.29,36.163c0,3.144-4.944,5.684-9.436,5.684a9.063,9.063,0,0,1-7.17-3,3.494,3.494,0,0,0-3.051-1.672l-25.793,1.2a2.212,2.212,0,1,1,0-4.414l25.8,1.192a3.477,3.477,0,0,0,3.051-1.672,9.063,9.063,0,0,1,7.17-3c4.493,0,9.436,2.541,9.436,5.679m1.113,0a4.252,4.252,0,0,0-.294-1.545,5.36,5.36,0,0,0-.785-1.354A7.474,7.474,0,0,0,72.2,32.126a9.834,9.834,0,0,0-1.4-.947,13.076,13.076,0,0,0-1.579-.76,14.772,14.772,0,0,0-3.531-.927,13.919,13.919,0,0,0-1.844-.123,12.673,12.673,0,0,0-2.452.235,11.584,11.584,0,0,0-2.222.682A8.387,8.387,0,0,0,55.8,32.8a3.624,3.624,0,0,1-.981.981,2.722,2.722,0,0,1-1.182.27l-25.749-1.2a3.193,3.193,0,0,0-1.339.216,3.252,3.252,0,0,0-1.108.7,3.315,3.315,0,0,0,0,4.8,3.252,3.252,0,0,0,1.108.7,3.193,3.193,0,0,0,1.339.221l25.749-1.2a2.723,2.723,0,0,1,1.183.27,3.624,3.624,0,0,1,.98.981,8.387,8.387,0,0,0,3.374,2.511,11.242,11.242,0,0,0,2.222.677,12.3,12.3,0,0,0,2.452.24,13.921,13.921,0,0,0,1.845-.123,14.774,14.774,0,0,0,3.531-.927,13.076,13.076,0,0,0,1.579-.77,9.832,9.832,0,0,0,1.388-.947,7.475,7.475,0,0,0,1.128-1.138,5.361,5.361,0,0,0,.785-1.354,4.262,4.262,0,0,0,.294-1.55Z",
    transform: "translate(-0.383 0)",
    fill: "#262c62",
    stroke: "#262c62",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_7322",
    "data-name": "Raggruppa 7322",
    transform: "translate(-586.723 -224.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SEGUNDO_PLATO",
    "data-name": "SEGUNDO PLATO",
    transform: "translate(698.563 415.41)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_298",
    "data-name": "Ellisse 298",
    cx: 18.469,
    cy: 18.469,
    r: 18.469,
    transform: "translate(26.447 26.125)",
    fill: "rgba(0,0,0,0)",
    stroke: "#262c62",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_299",
    "data-name": "Ellisse 299",
    cx: 12.315,
    cy: 12.315,
    r: 12.315,
    transform: "translate(32.601 32.279)",
    fill: "rgba(0,0,0,0)",
    stroke: "red",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_806",
    "data-name": "Linea 806",
    y2: 9.236,
    transform: "translate(19.266 24.07)",
    fill: "none",
    stroke: "#262c62",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_15998",
    "data-name": "Tracciato 15998",
    d: "M15.16,24.07V35.353a2.055,2.055,0,0,0,2.055,2.055v25.65a2.051,2.051,0,1,0,4.1,0V37.413a2.051,2.051,0,0,0,2.051-2.055V24.074",
    fill: "rgba(0,0,0,0)",
    stroke: "#262c62",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "GUARNICION",
    transform: "translate(208.43 187.334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_15999",
    "data-name": "Tracciato 15999",
    d: "M63.492,44.447a.827.827,0,1,1,.827.846A.837.837,0,0,1,63.492,44.447Zm-23.62-8.8a1.362,1.362,0,1,0,1.362-1.395A1.4,1.4,0,0,0,39.872,35.652ZM54.841,46.539A1.362,1.362,0,1,0,56.2,45.144a1.4,1.4,0,0,0-1.362,1.395ZM23.63,40.961a1.283,1.283,0,1,0-1.255-1.278A1.264,1.264,0,0,0,23.63,40.97Zm-1.255,5.578a.846.846,0,1,0-.827-.841.832.832,0,0,0,.827.874Zm20.286-5.248c2.761-1.715,4.923-1.832,5.927-.316a7.426,7.426,0,0,1,.646,6.187,2.027,2.027,0,0,1-1.673,1.3h-.135c-.614.056-1.357.13-2.1.13-1.618,0-3.254-.339-3.528-1.892-.144-.786-.311-1.859-.428-2.631A2.789,2.789,0,0,1,42.661,41.291Zm.753,2.478c.158,1.051.3,1.915.4,2.51.232.191,1.023.353,3.44.116h.051c.4-.465.432-2.952-.428-4.244-.237-.358-1.515-.1-3.17.93a.683.683,0,0,0-.321.688ZM28.832,24.97a1.024,1.024,0,0,1,1.971-.558,4.649,4.649,0,0,0,1.218,1.808l.056.042c2.282-.874,4.8-.8,6.508,1.185a7.652,7.652,0,0,1,1.692,3.635,1.241,1.241,0,0,1,0,.321.953.953,0,0,1-.721.962c-2.473.693-5.43.846-7.2-1.395a6.043,6.043,0,0,1-1.185-2.789A6.434,6.434,0,0,1,28.832,24.97Zm4.4,3.091a3.858,3.858,0,0,0,.525,1.339c.958,1.492,2.7,1.515,4.272,1.2a5.89,5.89,0,0,0-.669-1.362C36.321,27.7,34.787,27.6,33.234,28.061ZM70.4,52.5,58.667,69.954a3.254,3.254,0,0,1-2.71,1.46H29.371a3.254,3.254,0,0,1-2.715-1.46L14.923,52.5a2.055,2.055,0,0,1-.121-2.1,1.98,1.98,0,0,1,1.762-1.088H68.759A1.98,1.98,0,0,1,70.521,50.4,2.055,2.055,0,0,1,70.4,52.5ZM63.892,58.5H21.436l6.9,10.264a1.241,1.241,0,0,0,1.032.558H55.956a1.241,1.241,0,0,0,1.027-.558ZM68.666,51.4h-52l3.37,5.016H65.291Z",
    transform: "translate(0 0)",
    fill: "#262c62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_16000",
    "data-name": "Tracciato 16000",
    d: "M42.6,51.364l-.6-.549a1.994,1.994,0,0,1,.13-3.054,6.336,6.336,0,0,1,8.116.372,6.685,6.685,0,0,1,1.283,8.2,1.911,1.911,0,0,1-1.357.93,1.8,1.8,0,0,1-.311.028,1.9,1.9,0,0,1-1.283-.5h0l-.6-.549a7.651,7.651,0,0,1-.553.725,5.855,5.855,0,0,1-4.184,2.208,2.915,2.915,0,0,1-2-.734c-1.534-1.395-1.218-4.235.721-6.457A8.368,8.368,0,0,1,42.6,51.364Zm.865-2.008.865.8h0l4.607,4.184h0l.883.8a4.565,4.565,0,0,0-.93-5.467,4.319,4.319,0,0,0-5.425-.325ZM42.6,56.9c.567.521,2.106.074,3.305-1.3a5.839,5.839,0,0,0,.539-.734l-2.324-2.1a5.174,5.174,0,0,0-.646.632C42.284,54.772,42.028,56.38,42.6,56.9Z",
    transform: "translate(-13.754 -12.203)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_16001",
    "data-name": "Tracciato 16001",
    d: "M87.338,36.39l-.632.507a1.906,1.906,0,0,1-1.622.372,1.943,1.943,0,0,1-1.3-1.046,6.675,6.675,0,0,1,1.794-8.1,6.336,6.336,0,0,1,8.126.163,1.952,1.952,0,0,1,.679,1.534,1.775,1.775,0,0,1-.028.316,1.957,1.957,0,0,1-.711,1.2h0l-.632.511a7.623,7.623,0,0,1,.6.679,6.2,6.2,0,0,1,1.395,4.607,3.017,3.017,0,0,1-1.06,1.859c-1.618,1.3-4.3.465-6.09-1.859A7.437,7.437,0,0,1,87.338,36.39Zm-1.78-1.227.93-.744h0l4.858-3.886h0l.93-.748a4.323,4.323,0,0,0-5.434,0,4.551,4.551,0,0,0-1.283,5.378Zm7.112,2.208c.6-.465.465-2.1-.669-3.556a5.234,5.234,0,0,0-.609-.669l-2.431,1.948a5.644,5.644,0,0,0,.493.767C90.564,37.31,92.071,37.854,92.67,37.371Z",
    transform: "translate(-36.681 -1.64)",
    fill: "red"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POSTRE",
    transform: "translate(299.036 196.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_16002",
    "data-name": "Tracciato 16002",
    d: "M60.721,34.316a9.22,9.22,0,0,0-6.639-4.4,14.233,14.233,0,0,0-1.747-.112,9.259,9.259,0,0,0-6.2,2.111c0-1.71.283-7.494,4.646-11.549a.7.7,0,1,0-.955-1.03,15.147,15.147,0,0,0-3.345,4.557,6.092,6.092,0,0,0-6.319-3.617A6.821,6.821,0,0,1,34.1,17.489a.7.7,0,0,0-1.29.357c0,.29-.16,7.063,5.416,9.865a7.624,7.624,0,0,0,3.446.851h0a7.564,7.564,0,0,0,3.5-.881,18.879,18.879,0,0,0-.457,4.2A9.185,9.185,0,0,0,38.549,29.8a14.232,14.232,0,0,0-1.747.112,9.278,9.278,0,0,0-6.639,4.4A16.17,16.17,0,0,0,28.81,47.75c2.476,7.9,8.653,12.267,12.159,12.408A5.483,5.483,0,0,0,45.429,58.2a5.5,5.5,0,0,0,4.241,1.959h.238c3.505-.126,9.683-4.505,12.159-12.408A16.156,16.156,0,0,0,60.721,34.316ZM41.682,27.157a6.208,6.208,0,0,1-2.818-.7c-3.063-1.539-4.089-4.613-4.461-6.631a8.319,8.319,0,0,0,5.84,1.851A4.824,4.824,0,0,1,45.6,25.763,6.542,6.542,0,0,1,41.682,27.157ZM60.736,47.33c-2.253,7.185-7.858,11.315-10.873,11.423h-.175a4.089,4.089,0,0,1-3.613-2.111.7.7,0,0,0-1.256,0,4.089,4.089,0,0,1-3.613,2.111h-.175c-3.015-.108-8.624-4.238-10.873-11.423-1.353-4.312-.9-9.007,1.193-12.267a7.794,7.794,0,0,1,5.635-3.773,12.809,12.809,0,0,1,1.572-.1A7.764,7.764,0,0,1,44.013,33.1a2.3,2.3,0,0,0,2.974-.1,7.76,7.76,0,0,1,5.345-1.81,12.809,12.809,0,0,1,1.572.1,7.808,7.808,0,0,1,5.635,3.773C61.632,38.323,62.089,43.018,60.736,47.33Z",
    fill: "#262c62",
    stroke: "#262c62",
    strokeMiterlimit: 10,
    strokeWidth: 0.97
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_16003",
    "data-name": "Tracciato 16003",
    d: "M42.276,62.87c-.059.03-5.65,3.074-3.312,11.713a.7.7,0,0,0,.677.554.617.617,0,0,0,.182-.026.7.7,0,0,0,.494-.859c-2.033-7.512,2.42-10.007,2.6-10.111a.712.712,0,0,0-.643-1.271Z",
    transform: "translate(-6.553 -28.669)",
    fill: "red",
    stroke: "red",
    strokeMiterlimit: 10,
    strokeWidth: 0.97
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeHp);
export default __webpack_public_path__ + "static/media/icone-hp.56fe95c8b2208efdd534719ed97b66ed.svg";
export { ForwardRef as ReactComponent };